import { withPluginApi } from "discourse/lib/plugin-api";

const PLUGIN_ID = "discourse-community-navigation";

export default {
  name: "community-navigation-admin-plugin-configuration-nav",

  initialize(container) {
    const currentUser = container.lookup("service:current-user");
    if (!currentUser?.admin) {
      return;
    }

    withPluginApi((api) => {
      api.setAdminPluginIcon(PLUGIN_ID, "sitemap");
      api.addAdminPluginConfigurationNav(PLUGIN_ID, [
        {
          label: "community_navigation.admin.structure.title",
          route: "adminPlugins.show.community-navigation-structure",
          description: "community_navigation.admin.structure.description",
        },
      ]);
    });
  },
};
